import { createStylesHook } from '@maui/system'

export const styles = {
  base: {
    backgroundColor: 'colorBackgroundPage',
    border: '0',
    borderRadius: '0',
    boxShadow: 'shadowModalDialog',
    display: 'flex',
    flexDirection: 'column',
    right: '0',
    margin: '0 auto',
    outline: 'none',
    padding: '0',
    position: 'absolute',
    top: '48px',
    bottom: '0',
    width: '500px',
  },
}

export const useDrawerContentStyles = createStylesHook({
  name: 'DrawerContent',
  ...styles,
})
